<template>
  <img
    class="m-3 fetching"
    v-if="!Gifts"
    src="base/img/loading.gif"
    width="80"
  />
  <template v-else>
    <div class="col-xl-4 col-md-6" style="min-width: 220px">
      <section
        class="
          investmentSummaryBox
          w3-theme-d5
          card
          w3-white
          mb-4
          column
          w3-border
          p-0
        "
      >
        <div class="investmentSummary card-body bg-transparent m-0 pb-3">
          <div class="mt-3 mb-5 size18 bold">Gifts I Purchased</div>
          <div class="w3-cell-row">
            <div class="w3-cell w3-cell-top">
              <div class="w3-left-align">
                <p class="mt-0 mb-1 size12 bold w3-text-orange">TOTAL VALUE</p>
                <p class="size16 bold mt-0 mb-2 w3-text-white">
                  {{ formatCurrency(myPurchase.value, "&#8358;") }}
                </p>
              </div>
            </div>
            <div class="w3-cell w3-cell-top">
              <div class="w3-right-align">
                <p class="mt-0 mb-1 size12 bold w3-text-orange">TOTAL AMOUNT</p>
                <p class="size16 bold mt-0 mb-2 w3-text-white">
                  {{ formatCurrency(myPurchase.amount, "&#8358;") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="col-xl-4 col-md-6" style="min-width: 220px">
      <section
        class="
          investmentSummaryBox
          w3-theme-d5
          card
          w3-white
          mb-4
          column
          w3-border
          p-0
        "
      >
        <div class="investmentSummary card-body bg-transparent m-0 pb-3">
          <div class="mt-3 mb-5 size18 bold">Gift Vouchers For Me</div>

          <div class="w3-cell-row">
            <div class="w3-cell w3-cell-top">
              <div class="w3-left-align">
                <p class="mt-0 mb-1 size12 bold w3-text-orange">TOTAL VALUE</p>
                <p class="size16 bold mt-0 mb-2 w3-text-white">
                  {{ formatCurrency(myGifts.value, "&#8358;") }}
                </p>
              </div>
            </div>
            <div class="w3-cell w3-cell-top">
              <div class="w3-right-align">
                <p class="mt-0 mb-1 size12 bold w3-text-orange">TOTAL AMOUNT</p>
                <p class="size16 bold mt-0 mb-2 w3-text-white">
                  {{ formatCurrency(myGifts.amount, "&#8358;") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>
</template>
<script>
import { formatCurrency } from "@/helpers/utilities";
import { onMounted, ref, toRef } from "vue";
export default {
  components: {},
  props: ["gifts"],
  emits: ["equalHeightColumns"],
  setup(props, { emit }) {
    const Gifts = toRef(props, "gifts");
    const myGifts = ref({ value: 0, amount: 0 });
    const myPurchase = ref({ value: 0, amount: 0 });
    if (Gifts.value.GiftsPurchased && Gifts.value.GiftsPurchased.length) {
      for (let i = 0; i < Gifts.value.GiftsPurchased.length; i++) {
        let gift = Gifts.value.GiftsPurchased[i];
        myPurchase.value.value += gift.GiftValue;
        myPurchase.value.amount += gift.GiftAmount;
      }
    }

    if (Gifts.value.GiftsList && Gifts.value.GiftsList.length) {
      for (let i = 0; i < Gifts.value.GiftsList.length; i++) {
        let gift = Gifts.value.GiftsList[i];
        myGifts.value.value += gift.GiftValue;
        myGifts.value.amount += gift.GiftAmount;
      }
    }
    onMounted(() => {
      emit("equalHeightColumns");
    });
    return {
      formatCurrency,
      Gifts,
      myPurchase,
      myGifts,
    };
  },
};
</script>
<style scoped>
.investmentSummaryBox {
  max-width: 100%;
}
.investmentSummary {
  background-color: #8d1d1c;
  background-image: url("/base/img/bg-1.png");
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
}
.investmentSummary p {
  line-height: normal !important;
}
</style>
